export enum AGENT_TYPES {
  Agency = 'agency',
  Company = 'company',
  Agent = 'agent',
}
